<script lang="ts" setup>
import type ImageType from '~/enums/image-type'
import { ProductStatus } from '~/enums/product-status'
import helpers from '~/helpers'
import type { CartProductData } from '~/types/cart'
import type { ProductData } from '~/types/products'

const props = defineProps<{
  imageTypes: ImageType[]
  productData: ProductData | CartProductData
}>()

const imageClassList = 'max-h-full max-w-full object-contain'
const wrapperClassList = 'flex size-16 min-h-16 min-w-16 items-center justify-center overflow-hidden rounded-sm'

// const isProductImageBlackAndWhite = computed(() => helpers.isProductImageBlackAndWhite(props.productData)) // grayscale
const isProductPublished = computed(() => props.productData.attributes.statusId === ProductStatus.Published);
const productImageUrl = computed(() => helpers.getProductImageUrl(props.productData, props.imageTypes));
const productName = computed(() => props.productData.attributes.name);
const productPath = computed(() => helpers.getProductPath(props.productData));
const productSlug = computed(() => props.productData.attributes.slug);
</script>

<template>
  <NuxtLink v-if="isProductPublished && productSlug" :class="wrapperClassList" :to="productPath">
    <img
      v-if="productImageUrl"
      v-lazy="productImageUrl"
      :alt="productName"
      :class="imageClassList"
      loading="lazy"
    >
  </NuxtLink>
  <div v-else :class="wrapperClassList">
    <img
      v-if="productImageUrl"
      v-lazy="productImageUrl"
      :alt="productName"
      :class="imageClassList"
      loading="lazy"
    >
  </div>
</template>
